module.exports = __webpack_public_path__ + "static/media/ConsumerGoods.38775c30.svg";